import { Alert, Input, Modal, Radio, message } from "antd";
import { useEffect, useState } from "react";
import {
  ERROR_CODE,
  REASON_OPTIONS,
  RELOAD_ERROR_CODES,
  STATUS,
  TRANSITION_ACTION,
} from "features/ConsultRequest/core/constants";
import { changeConsultStatus } from "features/ConsultRequest/data/apiAdapters";
import { useConsultCall } from "features/ConsultRequest/data/hooks";

const NEEDS_REASON = [STATUS.LOST, STATUS.CANCELLED];
const NOTE_MAX = 500;

export const canConfirmStatusChange = ({ toStatus, reasonCode, reasonNote }) => {
  if (!NEEDS_REASON.includes(toStatus)) return true;
  if (!reasonCode) return false;
  return reasonCode !== "OTHER" || Boolean(reasonNote?.trim());
};

/** PW7. onChanged(detail): 200 -> thay Detail; onStale(): lỗi phải tải lại PW4. */
export default function StatusChangeModal({ visible, toStatus, request, onClose, onChanged, onStale }) {
  const { call } = useConsultCall();
  const [reasonCode, setReasonCode] = useState(null);
  const [reasonNote, setReasonNote] = useState("");
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);
  const needsReason = NEEDS_REASON.includes(toStatus);

  useEffect(() => {
    if (visible) {
      setReasonCode(null);
      setReasonNote("");
      setError(null);
    }
  }, [visible, toStatus]);

  const submit = async () => {
    setSaving(true);
    try {
      const payload = { toStatus, version: request.version };
      if (needsReason) {
        payload.reasonCode = reasonCode;
        payload.reasonNote = reasonNote.trim() || null;
      }
      const detail = await call(changeConsultStatus, request.id, payload);
      onChanged?.(detail);
      onClose();
    } catch (e) {
      if (e.code === ERROR_CODE.VALIDATION_ERROR || e.code === ERROR_CODE.REASON_REQUIRED) {
        setError(e);
      } else {
        message.error(e.message);
        if (RELOAD_ERROR_CODES.includes(e.code)) {
          onStale?.();
          onClose();
        }
      }
    } finally {
      setSaving(false);
    }
  };

  const label = TRANSITION_ACTION[toStatus]?.label;
  const missingReason = needsReason && !reasonCode;
  return (
    <Modal
      title={label}
      visible={visible}
      onCancel={onClose}
      onOk={submit}
      okText="Xác nhận"
      cancelText="Hủy"
      okButtonProps={{ disabled: !canConfirmStatusChange({ toStatus, reasonCode, reasonNote }), loading: saving }}
      destroyOnClose
    >
      {!needsReason && <p>{`Xác nhận "${label}" cho phiếu này?`}</p>}
      {needsReason && (
        <>
          <Alert
            type="warning"
            message="Đây là trạng thái cuối, phiếu sẽ bị khóa sau khi xác nhận."
            style={{ marginBottom: 12 }}
          />
          <Radio.Group
            value={reasonCode}
            onChange={(e) => setReasonCode(e.target.value)}
            style={{
              display: "flex",
              flexDirection: "column",
              gap: 8,
              border: missingReason ? "1px solid #D8001A" : "none",
              padding: 8,
            }}
          >
            {REASON_OPTIONS[toStatus].map((o) => (
              <Radio key={o.value} value={o.value}>
                {o.label}
              </Radio>
            ))}
          </Radio.Group>
          {missingReason && (
            <div style={{ color: "#D8001A" }}>
              {toStatus === STATUS.LOST ? "Vui lòng chọn lý do không chốt" : "Vui lòng chọn lý do hủy phiếu"}
            </div>
          )}
          <Input.TextArea
            style={{ marginTop: 12 }}
            rows={3}
            maxLength={NOTE_MAX}
            placeholder={reasonCode === "OTHER" ? "Ghi chú (bắt buộc)" : "Ghi chú (tùy chọn)"}
            value={reasonNote}
            onChange={(e) => setReasonNote(e.target.value)}
          />
        </>
      )}
      {error && <Alert type="error" message={error.errors?.[0]?.message || error.message} style={{ marginTop: 12 }} />}
    </Modal>
  );
}
